import { createContext, useState } from "react";
import { implRequired } from "../util/util";

const DisplayContext = createContext({
    isHeaderSearchEnabled: true,
    toggleHeaderSearch: (enable) => implRequired("toggleHeaderSearch")
})

const DisplayContextProvider = ({ children }) => {
    const [isHeaderSearchEnabled, setIsHeaderSearchEnabled] = useState(true)

    const toggleHeaderSearch = (enable) =>
setIsHeaderSearchEnabled(() => enable)

    return (
        <DisplayContext.Provider value={{
            isHeaderSearchEnabled,
            toggleHeaderSearch
        }}>
            { children }
        </DisplayContext.Provider>
    )
}

export default DisplayContext
export { DisplayContextProvider }
